import { AxiosInstance, isAxiosError } from "axios";
import { Filter } from "./filter";
import { NotificacaoPortaria } from "./notificacao-portaria";
import { Pagination } from "../../pagination";

export class NotificacaoPortariaRepository {
    constructor(
        private api: AxiosInstance
    ) { }

    async search(filter?: Filter, pagination?: Pagination): Promise<NotificacaoPortaria[]> {
        try {
            let { data } = await this.api.get<NotificacaoPortaria[]>(`mural/notificacao-portaria/search`, {
                params: {
                    ...filter,
                    ...pagination
                }
            })
            return data
        } catch (error) {
            let message = 'Não foi possível buscar as notificações';
            if (isAxiosError(error)) {
                message = error.response?.data?.error || "Não foi possível buscar as notificações"
            } else if (error instanceof Error) {
                message = error.message
            }
            throw new Error(message);

        }
    }

    async searchOne(filter?: Filter): Promise<NotificacaoPortaria> {
        try {
            let { data } = await this.api.get<NotificacaoPortaria>(`mural/notificacao-portaria/search-one`, {
                params: {
                    ...filter
                }
            })
            return data
        } catch (error) {
            let message = 'Notificação não encontrada';
            if (isAxiosError(error)) {
                message = error.response?.data?.error || "Notificação não encontrada"
            } else if (error instanceof Error) {
                message = error.message
            }
            throw new Error(message);
        }
    }

    async count(filter?: Filter): Promise<number> {
        try {
            let { data } = await this.api.get<number>(`mural/notificacao-portaria/count`, {
                params: {
                    ...filter
                }
            })
            return data
        } catch (error) {
            let message = 'Não foi possível contar as notificações';
            if (isAxiosError(error)) {
                message = error.response?.data?.error || "Não foi possível contar as notificações"
            } else if (error instanceof Error) {
                message = error.message
            }
            throw new Error(message);
        }
    }

    async save(record: NotificacaoPortaria): Promise<NotificacaoPortaria> {
        try {
            let { data } = await this.api.post<NotificacaoPortaria>(`mural/notificacao-portaria/save`, {
                ...record
            })
            return data
        } catch (error) {
            let message = 'Não foi possível salvar a notificação';
            if (isAxiosError(error)) {
                message = error.response?.data?.error || "Não foi possível salvar a notificação"
            } else if (error instanceof Error) {
                message = error.message
            }
            throw new Error(message);
        }
    }

    async remove(filter?: Filter): Promise<void> {
        try {
            await this.api.delete<NotificacaoPortaria>(`mural/notificacao-portaria/remove`, {
                params: {
                    ...filter
                }
            })
        } catch (error) {
            let message = 'Não foi possível remover as notificações';
            if (isAxiosError(error)) {
                message = error.response?.data?.error || "Não foi possível remover as notificações"
            } else if (error instanceof Error) {
                message = error.message
            }
            throw new Error(message);
        }
    }
}